import React, { useState } from 'react';
import ClientIrccStudy from './ClientIrccStudy';
export { isStudyProcedure } from './ClientIrccStudy';

export default function ClientIrccStudyDocuments({ client }) {
  const [active, setActive] = useState('study');
  const id = `ircc-documents-${client?.id}`;
  return <div className="ircc-study-documents">
    <div className="ircc-study-documents__tabs" role="tablist" aria-label="Formulaires IRCC du dossier d’études">
      <button type="button" role="tab" id={`${id}-study-tab`} aria-selected={active === 'study'} aria-controls={`${id}-study-panel`} onClick={() => setActive('study')}>IMM1294 — Permis d’études</button>
      <button type="button" role="tab" id={`${id}-family-tab`} aria-selected={active === 'family'} aria-controls={`${id}-family-panel`} onClick={() => setActive('family')}>IMM5645 — Informations sur la famille</button>
    </div>
    {/* Keep both drafts mounted: switching documents must not lose unsaved text. */}
    <div role="tabpanel" id={`${id}-study-panel`} aria-labelledby={`${id}-study-tab`} hidden={active !== 'study'} style={{ display: active === 'study' ? 'block' : 'none' }}>
      <ClientIrccStudy client={client} />
    </div>
    <div role="tabpanel" id={`${id}-family-panel`} aria-labelledby={`${id}-family-tab`} hidden={active !== 'family'} style={{ display: active === 'family' ? 'block' : 'none' }}>
      <ClientIrccStudy client={client} formType="family" />
    </div>
  </div>;
}
